



























import axios from "axios";
import Vue from "vue";
import profile from "@/interfaces/profile";

export default Vue.extend({
	props: ["data"],

	data() {
		return {
			profileName: "" as string,
		};
	},

	watch: {},

	methods: {
		handleOk(bvModalEvt: any) {
			bvModalEvt.preventDefault();
			this.handleSubmit();
		},
		handleSubmit() {
			console.log(this.$props.data);
			axios
				.post("profile/profile", {
					tyonhakijaId: this.$props.data.uid,
					perusprofiili: false,
					profiilinimi: this.$data.profileName,
				} as profile)
				.then((x) => {
					console.log(x);
					this.$emit("updateData");
				});
			this.$nextTick(() => {
				this.$bvModal.hide("ask-profile");
			});
		},
		hideModal() {
			this.$bvModal.hide("ask-profile");
		},
	},
});
